export const ROUTES = {
    LOBBY: 'lobby',
    INTEGRATION: 'integration',
    GAME: 'game',
    BET_HISTORY: 'bet-history',
};

export const SUB_ROUTES = {
    HOW_TO_PLAY: 'how-to-play',
    PARTICIPANTS: 'participants',
    CURRENT: 'current',
    UPCOMING: 'upcoming',
    PAST: 'past',
    STANDINGS: 'standings',
    MATCH_INFO: 'match_info',
    RESULTS: 'results',
};
